// extracted by mini-css-extract-plugin
export default {"add-question":"addObject_add-question__zW-qw","row":"addObject_row__5QT8e","actions":"addObject_actions__N40Cg"};